import { render, staticRenderFns } from "./PlanImage.vue?vue&type=template&id=164b6e24&"
import script from "./PlanImage.vue?vue&type=script&lang=js&"
export * from "./PlanImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports